import React, { Component } from 'react';
import dateTimeHelper from '../Helpers/datetimeHelper';


class CaspianTimePicker extends Component 
{

    constructor (props) 
    {
        super(props);


        this.state = {
            selected: props.selectedDate,
            onChange: props.onChange,
        };

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.assignRef = this.assignRef.bind(this);
    }

    componentDidMount () 
    {

    }

    componentDidUpdate (prevProps, prevState, snapshot)
    {
        if (prevProps.selectedDate !== this.props.selectedDate)
        {
            this.setState({ selected: this.props.selectedDate });
        }

        // Only restore the caret after an arrow-key increment (below). Doing this on
        // every update — including normal typing — forced the caret to a stale offset,
        // so typing a digit at the end jumped the caret back one character.
        if (this.restoreCaret && dateTimeHelper.isItAValidTime(this.inputRef.value))
        {
            this.inputRef.setSelectionRange(this.position, this.position);
        }
        this.restoreCaret = false;
    }

    handleKeyDown (e)
    {
        if (e.keyCode === 38 || e.keyCode === 40)
        {
            this.position = e.target.selectionStart;
            this.restoreCaret = true;
            e.preventDefault();
            if (dateTimeHelper.isItAValidTime(this.state.selected))
            {
                let minutes = dateTimeHelper.convertTimeToMinutes(this.state.selected);
                const change = this.position < 3 ? 60 : 5;
                if (e.keyCode === 38) {
                  minutes += change;
                } else if (e.keyCode === 40) {
                  minutes -= change;
                }

                const newTime = dateTimeHelper.convertMinutesToTime(minutes);
                this.setState({ selected: newTime });
                this.props.onChange(newTime);
            }
        }
    }

    assignRef (c) 
    {
        this.inputRef = c;
    }


    render ()
    {
        return (
            <>
                {/* <Select 
                    className={this.props.className}
                    selected={this.state.selected}
                    options={options} 
                    onChange={(e)=>this.setState({selected:e.value})}
                /> */}
                <input
                    className='w-100 form-control'
                    value={this.state.selected}
                    ref={this.assignRef}
                    onChange={(e) => 
                    {
                        this.setState({ selected: e.target.value });
                        this.props.onChange(e.target.value);
                    }}
                    onKeyDown={this.handleKeyDown}
                    disabled={this.props.disabled}
                />
                {!dateTimeHelper.isItAValidTime(this.state.selected) && (
                    <div className='ds-fieldhint'>Use the format hh:mm</div>
                )}

            </>
        );
    }


}


export default CaspianTimePicker;
